<div class="wrapper-support-form">
  <div class="header" [ngClass]="{ 'fixed-header': true }">
    <div class="wrapper-header" [ngClass]="{ 'dark-header': isDarkMode() }">
      <div class="row align-items-center">
        <div class="site-logo-area col-md-2 col-8" [ngClass]="false ? 'col-md-10' : 'col-md-2'">
          <div class="site-logo">
            <a href=""><img src="../../../assets/images/logo.png" class="logo" /></a>
          </div>
        </div>
        <div class="col-md-8 text-center" *ngIf="moduleTitle as title">
          <span></span>
          <label class="logoText">{{ title }}</label>
        </div>
        <div class="col-md-2 col-4 text-right text-end ml-auto ms-auto header-profile-col">
          <div class="wrapper-profile-info">
            <div class="logo-profile-image">
              <img width="60" height="50" [src]="profileImageUrl" alt="" *ngIf="profileImageUrl; else textAvatar" />
              <ng-template #textAvatar>
                <div class="avatar-text">
                  <span class="altTitle"> {{ getInitial(username) }}</span>
                </div>
              </ng-template>
            </div>
            <div class="wrap-profile-info-popup" [ngClass]="{ 'dark-popup': isDarkMode() }">
              <div class="modesIcon">
                <button mat-icon-button (click)="toggleDarkMode()">
                  <mat-icon class="items" [ngClass]="{ 'dark-buttons': isDarkMode() }">{{ isDarkMode() ? "wb_sunny" :
                    "bedtime" }}</mat-icon>
                </button>
              </div>
              <div class="profile-info-header">
                <div class="row align-items-center">
                  <div class="col-picture">
                    <img width="50" height="40" [src]="profileImageUrl" alt=""
                      *ngIf="profileImageUrl; else textAvatar1" />
                    <ng-template #textAvatar1>
                      <div class="avatar-text1">
                        <span class="altTitle1">
                          {{ getInitial(username) }}</span>
                      </div>
                    </ng-template>
                  </div>

                  <div class="col-user-title-email text-left">
                    <!-- <h5
                      class="organization mb-0"
                      [ngClass]="{ 'dark-text': isDarkMode() }"
                      *ngIf="isRestrictedUser()"
                    >
                      {{ username }}
                    </h5> -->
                    <h5 class="organization mb-0" [ngClass]="{ 'dark-text': isDarkMode() }"
                      *ngIf="username === 'Eiger Shipping'">
                      {{ ClientUsername }}
                    </h5>
                    <h5 class="organization mb-0" [ngClass]="{ 'dark-text': isDarkMode() }"
                      *ngIf="username !== 'Eiger Shipping'">
                      {{ bungeUsername }}
                    </h5>
                    <p class="organization-email mb-0">
                      {{ email }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="wrapper-profile-info-body">
                <ul class="ul-profile-menu-item" *ngIf="username !== 'Zeronorth ZN'">
                  <li (click)="userGuideClick()">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">article</mat-icon>
                      User Guide
                    </a>
                  </li>
                  <li (click)="onboardingFormClick()"
                    *ngIf="username === 'Meraki - Operations' && (bungeUsername === 'meraki_superadmin'|| bungeUsername === 'meraki_admin')">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">settings</mat-icon>
                      Onboarding Form
                    </a>
                  </li>
                  <li (click)="apiUsageClick()"
                    *ngIf="username === 'Meraki - Operations' && (bungeUsername === 'meraki_superadmin'|| bungeUsername === 'meraki_admin')">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">insights</mat-icon>
                      API Usage
                    </a>
                  </li>
                  <li (click)="clientOwnershipClick()"
                    *ngIf="username === 'Meraki - Operations' && (bungeUsername === 'meraki_superadmin'|| bungeUsername === 'meraki_admin')">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">directions_boat</mat-icon>
                      Client Ownership
                    </a>
                  </li>
                  <li (click)="openProfileVesselQuestionnaire()" *ngIf="showProfileVesselQuestionnaire()">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">description</mat-icon>
                      Vessel Questionnaire
                    </a>
                  </li>
                  <li (click)="settingClick()">
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">settings</mat-icon>
                      tenant Specific Settings
                    </a>
                  </li>
                  <!-- Moved to Onboarding Form page -->
                  <!-- <li
                    (click)="q88Click()"
                    *ngIf="username === 'Meraki - Operations'"
                  >
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">description</mat-icon>
                     Vessel Questionnaire
                    </a>
                  </li>
                  <li
                    (click)="onboardingClick()"
                    *ngIf="username === 'Meraki - Operations' && (bungeUsername === 'meraki_superadmin'|| bungeUsername === 'meraki_admin')"
                  >
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">description</mat-icon>
                      Onboarding Vessels
                    </a>
                  </li> -->
                  <!-- <li
                    (click)="compareRouteClick()"
                    *ngIf="username === 'Meraki - Operations'"
                  >
                    <a [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">route</mat-icon>
                      Compare route
                    </a>
                  </li> -->
                </ul>
              </div>
              <div class="wrapper-profile-info-footer">
                <ul class="ul-profile-menu-item">
                  <li [ngClass]="{ 'dark-text': isDarkMode() }" (click)="onLogout()">
                    <a href="" [ngClass]="{ 'dark-text': isDarkMode() }">
                      <mat-icon class="items">exit_to_app</mat-icon>
                      Logout</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="fixed-nav">
  <nav class="navbar navbar-expand-lg" style="background-color: #00044a" [class.dark-nav]="isDark">
    <div class="menuButton col-md-1">
      <button mat-icon-button (click)="toggleSidebar()" (mouseenter)="openSidebar()" (mouseleave)="closeSidebar()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <div class="container-fluid col-md-11">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <!-- ================= EMISSION ANALYTICS ================= -->
        <ng-container *ngIf="isEmission">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/E-dashboard">Home</a>
          </li>

          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/E-ImoDcs">IMO DCS</a>
          </li>

          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/E-cii">CII</a>
          </li>

          <li class="nav-item nav dropdown emission">
            <a class="nav-link nav dropdown-toggle" id="emissionDropdown">
              EU/UK Compliance
            </a>
            <ul class="dropdown-menu" style="background-color: #00044a" [class.dark-dropdown-menu]="isDark">
              <li><a class="dropdown-item" routerLink="/E-euEts">EU ETS</a></li>
              <li>
                <a class="dropdown-item" routerLink="/E-fuelEU">FuelEU</a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/E-uk-mrv">UK MRV</a>
              </li>
            </ul>
          </li>

          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/E-Overview">
              Emission Overview
            </a>
          </li>
        </ng-container>

        <!-- ================= Disbursment ================= -->
        <ng-container *ngIf="isDisbursment">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/dis-dashboard">Dashboard</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/dis-request-form">Request Form</a>
          </li>
          <!-- <li class="nav-item nav" routerLinkActive="active" >
            <a class="nav-link nav" routerLink="/dis-my-requests">My Requests</a>
          </li> -->
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/dis-meraki-ai">Meraki AI</a>
          </li>

        </ng-container>
        <!-- ================= Demurrage ================= -->
        <ng-container *ngIf="isDemurrage">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/d-home">Home</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/d-form">Request Form</a>
          </li>

        </ng-container>

        <!-- ================= Port Performance ================= -->
        <ng-container *ngIf="isPortConsumption">
          <li class="nav-item nav" routerLinkActive="active" [hidden]="isZeronorth">
            <a class="nav-link nav" routerLink="/pc-home">Home</a>
          </li>

          <!-- <li
            class="nav-item nav"
            routerLinkActive="active"
            [hidden]="!isMeraki"
          >
            <a class="nav-link nav" routerLink="/pc-dashboard">Dashboard</a>
          </li> -->

          <!-- <li
            class="nav-item nav"
            routerLinkActive="active"
            [hidden]="!isMeraki"
          >
            <a class="nav-link nav" routerLink="/pc-requestForm"
              >Request Form</a
            >
          </li> -->

          <li class="nav-item nav" routerLinkActive="active" [hidden]="isZeronorth"
            *ngIf="isMeraki && loginPic !== 'demo'">
            <a class="nav-link nav" routerLink="/pc-myrequest">My Requests</a>
          </li>

          <li class="nav-item nav" routerLinkActive="active" [hidden]="isZeronorth" *ngIf="isMeraki">
            <a class="nav-link nav" routerLink="/pc-database">Database</a>
          </li>
        </ng-container>

        <!-- ================= Sailing Performance ================= -->
        <ng-container *ngIf="isVesselPerformance">
          <li class="nav-item nav" routerLinkActive="active" [hidden]="isZeronorth">
            <a class="nav-link nav" routerLink="/home">Home</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active" [hidden]="!isMeraki || loginPic === 'demo'">
            <a class="nav-link nav" routerLink="/vp-updateTable">
              Vessel Itinerary
            </a>
          </li>

          <li class="nav-item nav" routerLinkActive="active"
            [hidden]="!(isMeraki || isZeronorth) || loginPic === 'demo'">
            <a class="nav-link nav" routerLink="/vp-requestForm" [queryParams]="{ type: 'default' }">Request Form</a>
          </li>

          <li class="nav-item nav" routerLinkActive="active"
            [hidden]="!(isMeraki || isZeronorth) || loginPic === 'demo'">
            <a class="nav-link nav" routerLink="/vp-retriveForm">My Requests</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active" [hidden]="!(isMeraki) || loginPic === 'demo'">
            <a class="nav-link nav" routerLink="/vp-periodicReport">Periodic report</a>
          </li>

          <li class="nav-item nav" routerLinkActive="active" [hidden]="!isMeraki || loginPic === 'demo'">
            <a class="nav-link nav" routerLink="/vp-database">Database</a>
          </li>
        </ng-container>

        <!-- ================= Routing Engine ================= -->
        <ng-container *ngIf="isRoutingEngine">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/routing-request">New Request</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/routing-request-list">Requests List</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active" [hidden]="!isMeraki">
            <a class="nav-link nav" routerLink="/rm-routingMap">Route Manager</a>
          </li>
          <li class="nav-item nav" routerLinkActive="active" [hidden]="!isMeraki">
            <a class="nav-link nav" routerLink="/vp-requestForm" [queryParams]="{ type: 'initial' }">Initial Route
              Advice</a>
          </li>
        </ng-container>

        <!-- ================= CARGO HEATING ================= -->
        <ng-container *ngIf="(isMeraki || isCargoHeatingClient) && isCargoHeating">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/ch-allRequests"> Home </a>
          </li>
          <li class="nav-item nav" [class.active]="isCargoHeatingReportsActive()">
            <a class="nav-link nav" routerLink="/ch-reportTable"> Reports </a>
          </li>

          <li *ngIf="isMeraki" class="nav-item nav dropdown">
            <a class="nav-link nav dropdown-toggle" id="analyticsDropdown">
              Data Analytics
            </a>
            <ul class="dropdown-menu" style="background-color: #00044a" [class.dark-dropdown-menu]="isDark">

              <li>
                <a class="dropdown-item" routerLink="/ch-pivottable">
                  Thermodynamic Model
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/voyage-metrics">
                  Temperature Drop Algorithm
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/ch-benchmark">
                  Performance Benchmarking
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="isCargoHeatingClient" class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/ch-benchmark">
              Performance Benchmarking
            </a>
          </li>
        </ng-container>
        <!-- ================= PORT WEATHER ================= -->
        <ng-container *ngIf="isPortWeather">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/pw-home"> Home </a>
          </li>
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/pw-myrequest"> My Requests </a>
          </li>
        </ng-container>
        <ng-container *ngIf="bungeUsername === 'meraki_superadmin'">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/ais-vessels"> AIS Vessels </a>
          </li>
        </ng-container>
        <!-- <ng-container *ngIf="bungeUsername === 'Meraki - Operations' ">
          <li class="nav-item nav" routerLinkActive="active">
            <a class="nav-link nav" routerLink="/vp-test-page"> Fixed ETA </a>
          </li>
        </ng-container> -->

        <!-- ================= HTML Reports ================= -->
        <ng-container *ngIf="isMeraki && isHtmlReports"> </ng-container>
      </ul>
    </div>
  </nav>
</div>

<div class="notification-backdrop" *ngIf="isNotificationExpanded" (click)="toggleNotification()"></div>

<div class="notification-panel" [class.open]="isNotificationExpanded">
  <!-- Accent highlight strip -->
  <div class="panel-accent-bar"></div>

  <!-- Header Section -->
  <div class="panel-header-container">
    <div class="panel-header-top">
      <div class="header-title-wrap">
        <div class="header-icon-box">
          <mat-icon class="header-bell-icon">notifications_active</mat-icon>
          <span class="pulse-indicator" *ngIf="unreadDeviationCount > 0"></span>
        </div>
        <div>
          <h3 class="panel-title">Operations Alerts</h3>
          <span class="panel-subtitle">Speed & Route Deviations</span>
        </div>
      </div>

      <div class="header-actions">
        <button type="button" class="panel-action-btn refresh-btn" (click)="refreshAllNotifications()"
          [class.spinning]="isRefreshing" title="Refresh stream">
          <mat-icon>refresh</mat-icon>
        </button>
        <button type="button" class="panel-action-btn panel-close-btn" (click)="toggleNotification()" title="Close panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Quick Stats Ribbon -->
    <div class="quick-stats-ribbon">
      <div class="stat-chip" (click)="setNotificationTab('alerts')" [class.active]="activeNotificationTab === 'alerts'">
        <div class="stat-main">
          <span class="stat-label">Alerts</span>
          <span class="stat-val">{{ filteredNotifications.length }}</span>
        </div>
        <span class="stat-badge alert-badge" *ngIf="unreadDeviationCount > 0">
          {{ unreadDeviationCount }} new
        </span>
      </div>

      <div class="stat-chip" *ngIf="username === 'Meraki - Operations'" (click)="setNotificationTab('comments')"
        [class.active]="activeNotificationTab === 'comments'">
        <div class="stat-main">
          <span class="stat-label">Remarks</span>
          <span class="stat-val">{{ filteredComments.length }}</span>
        </div>
      </div>
    </div>

    <!-- Client Filter (for Meraki - Operations) -->
    <div class="client-filter-box" *ngIf="username === 'Meraki - Operations'">
      <div class="client-filter-row">
        <div class="filter-select-wrapper">
          <mat-icon class="select-icon">corporate_fare</mat-icon>
          <select class="client-select-modern" [ngModel]="selectedClient"
            (ngModelChange)="onClientFilterChange($event)">
            <option value="all">All Clients (Fleet-wide)</option>
            <option *ngFor="let client of clientOptions" [value]="client">
              {{ client }}
            </option>
          </select>
        </div>
        <div class="client-filter-pills">
          <button type="button" class="pill-btn" [class.active]="selectedClient === 'all'"
            (click)="selectAllClients()">All</button>
          <button type="button" class="pill-btn clear-pill" *ngIf="selectedClient && selectedClient !== 'all'"
            (click)="clearClientSelection()">Reset</button>
        </div>
      </div>
    </div>

    <!-- Modern Segmented Tabs (Alerts & Remarks only) -->
    <div class="segmented-tabs-nav">
      <button type="button" class="tab-button" [class.active]="activeNotificationTab === 'alerts'"
        (click)="setNotificationTab('alerts')">
        <mat-icon class="tab-icon">notifications</mat-icon>
        <span>Alerts</span>
        <span class="tab-counter" *ngIf="filteredNotifications.length > 0">{{ filteredNotifications.length }}</span>
      </button>

      <button type="button" class="tab-button" *ngIf="username === 'Meraki - Operations'"
        [class.active]="activeNotificationTab === 'comments'" (click)="setNotificationTab('comments')">
        <mat-icon class="tab-icon">chat_bubble_outline</mat-icon>
        <span>Remarks</span>
        <span class="tab-counter" *ngIf="filteredComments.length > 0">{{ filteredComments.length }}</span>
      </button>
    </div>
  </div>

  <!-- Panel Body Content Scroll Area -->
  <div class="panel-content-body">
    <!-- Only render the panel body while open -->
    <ng-container *ngIf="isNotificationExpanded">

    <!-- Loading Skeleton Indicator -->
    <div class="notification-loader-modern" *ngIf="isNotificationLoading">
      <div class="loader-spinner"></div>
      <span>Syncing alerts...</span>
    </div>



    <!-- ================================= TAB 2: ALERTS ================================= -->
    <div class="tab-view-container" *ngIf="activeNotificationTab === 'alerts' && !isNotificationLoading">
      <div class="empty-state-card" *ngIf="filteredNotifications.length === 0">
        <div class="empty-icon-wrap alert-empty">
          <mat-icon>check_circle</mat-icon>
        </div>
        <h4>No Active Alerts</h4>
        <p>All speed and route deviation alerts have been reviewed or are clear.</p>
      </div>

      <div class="alerts-list" *ngIf="filteredNotifications.length > 0">
        <div class="notification-card-modern"
          [ngClass]="{ unread: !n.is_read, read: n.is_read, 'deviation-card': n.type === 'deviation', 'speed-card': n.type === 'speed' }"
          *ngFor="let n of filteredNotifications"
          (click)="n.type === 'deviation' ? openMapPopup(n) : updateSpeedNotification(n)"
          [attr.title]="n.type === 'deviation' && !n.is_read ? 'Click to inspect deviation on map' : 'Click to acknowledge alert'">

          <div class="alert-top-row">
            <div class="alert-type-badge" [class.dev-badge]="n.type === 'deviation'"
              [class.spd-badge]="n.type === 'speed'">
              <mat-icon>{{ n.type === 'deviation' ? 'warning' : 'speed' }}</mat-icon>
              <span>{{ n.type === 'deviation' ? 'Route Deviation' : 'Speed Alert' }}</span>
            </div>
            <span class="alert-time">{{ n.created_at | date:'dd MMM yyyy, HH:mm':'UTC' }} UTC</span>
          </div>

          <div class="alert-vessel-row">
            <span class="alert-vessel-name">{{ n.vessel_name }}</span>
            <span class="alert-imo-pill">IMO {{ n.imo }}</span>
          </div>

          <!-- Deviation info -->
          <div class="deviation-body" *ngIf="n.type === 'deviation'">
            <div class="route-track">
              <span class="port-name">{{ n.from || 'Origin' }}</span>
              <mat-icon class="route-arrow">east</mat-icon>
              <span class="port-name">{{ n.to || 'Destination' }}</span>
            </div>
            <div class="deviation-metric-pill">
              <span>Deviation:</span>
              <strong>{{ n.deviation_distance | number:'1.0-2' }} nm</strong>
            </div>
          </div>

          <!-- Speed alert info -->
          <div class="speed-body" *ngIf="n.type === 'speed'">
            <div class="speed-alert-desc">
              {{ n.alert_type }}
            </div>
          </div>

          <div class="alert-footer-action">
            <span class="action-hint">{{ n.type === 'deviation' ? 'Click to inspect deviation on map' : 'Click to
              acknowledge alert' }}</span>
            <span class="unread-dot" *ngIf="!n.is_read"></span>
          </div>
        </div>
      </div>
    </div>

    <!-- ================================= TAB 3: REMARKS / COMMENTS ================================= -->
    <div class="tab-view-container" *ngIf="activeNotificationTab === 'comments' && username === 'Meraki - Operations'">
      <div class="empty-state-card" *ngIf="filteredComments.length === 0">
        <div class="empty-icon-wrap">
          <mat-icon>chat</mat-icon>
        </div>
        <h4>No Recent Remarks</h4>
        <p>No operator or vessel remarks recorded in the past 10 days.</p>
      </div>

      <div class="comments-list" *ngIf="filteredComments.length > 0">
        <div class="comment-card-modern" *ngFor="let c of filteredComments">
          <div class="comment-head">
            <div class="comment-vessel-meta">
              <mat-icon class="comment-ship-icon">directions_boat</mat-icon>
              <span class="comment-vessel-title">{{ c.vessel || 'Unknown Vessel' }}</span>
              <span class="comment-imo">(IMO {{ c.imo }})</span>
            </div>
            <span class="comment-time">{{ c.timestep | date:'dd MMM yyyy, HH:mm':'UTC' }}</span>
          </div>

          <div class="comment-content-box">
            <p>{{ c.comment }}</p>
          </div>

          <div class="comment-foot">
            <span class="client-tag-label">Client:</span>
            <span class="client-tag-val">{{ c.client_name }}</span>
          </div>
        </div>
      </div>
    </div>
    </ng-container>

  </div>
</div>
<mat-sidenav-container class="fullScreen">
  <mat-sidenav #sidenav opened mode="side" [style.width]="sideNavWidth" class="sidenav-root"
    (mouseenter)="openSidebar()" (mouseleave)="closeSidebar()">
    <mat-nav-list class="sidebar" [ngClass]="{
        'dark-sidebar': isDarkMode(),
        'sidebar--pc-module': isPortConsumption
      }">
      <!-- Notification Icon at Top -->
      <a mat-list-item class="navList" (click)="toggleNotification()" [ngClass]="{
          'active-item': isNotificationExpanded,
          'default-item': !isNotificationExpanded,
        }">
        <div>
          <mat-icon matListItemIcon [ngStyle]="{
              color: isNotificationExpanded ? activeColor : defaultColor,
            }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
            notifications
          </mat-icon>

          <span class="notification-badge" *ngIf="unreadDeviationCount > 0">
            {{ unreadDeviationCount }}
          </span>
          <span class="notificationTitle" [ngClass]="{ 'dark-sidebar': isDarkMode() }" *ngIf="isSidebarOpen" [ngStyle]="{
              color: isNotificationExpanded ? activeColor : defaultColor,
            }">Notifications</span>
        </div>
      </a>
      <a mat-list-item class="navList" (click)="toggleOperators()" [ngClass]="{
          'active-item': isOperatorsExpanded,
          'default-item': !isOperatorsExpanded,
        }" *ngIf="operatorIcon && module === 'Sailing Performance' && isMeraki">
        <mat-icon matListItemIcon [ngStyle]="{
            color: isOperatorsExpanded ? activeColor : defaultColor,
          }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">supervised_user_circle</mat-icon>
        <span matListItemTitle *ngIf="isSidebarOpen" [ngStyle]="{
            color: isOperatorsExpanded ? activeColor : defaultColor,
          }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">Operators</span>
      </a>

      <div [ngClass]="{ 'dark-mode': isDarkMode() }" *ngIf="isOperatorsExpanded" class="radio-buttons-group">
        <mat-radio-group [(ngModel)]="selectedOperator" (ngModelChange)="onOperatorChange($event)">
          <mat-radio-button value="myShips" class="radio-button-item" [disabled]="isMyShipsDisabled"><span
              [ngClass]="{ 'dark-text': isDarkMode() }">My Ships</span></mat-radio-button>
          <br />
          <mat-radio-button value="allShips" class="radio-button-item"><span
              [ngClass]="{ 'dark-text': isDarkMode() }">All Ships</span></mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="hover-wrapper" (mouseleave)="hoveredItem = null" *ngFor="let item of projectsItems">
        <a mat-list-item (mouseover)="showHoverImage($event, item)" class="navList" [activated]="isItemActive(item)"
          [ngClass]="{
            'active-item': isItemActive(item),
            'default-item': !isItemActive(item),
          }" (click)="toggleSubMenu(item)" [attr.href]="
            item.url &&
            (username === 'Zeronorth ZN' || username === 'Meraki - Operations')
              ? item.url
              : null
          " [attr.target]="
            item.url &&
            (username === 'Zeronorth ZN' || username === 'Meraki - Operations')
              ? '_blank'
              : null
          " *ngIf="canShow(item)">
          <mat-icon matListItemIcon [ngStyle]="{
              color: isItemActive(item) ? 'activeColor' : 'defaultColor',
            }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
            {{ item.icon }}
          </mat-icon>
          <span matListItemTitle [ngStyle]="{
              color: isItemActive(item) ? 'activeColor' : 'defaultColor',
            }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
            {{ item.label }}
            <span>
              <mat-icon [ngStyle]="{
                  color: isItemActive(item) ? 'activeColor' : 'defaultColor',
                }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" class="arrows">
                {{
                item.expanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
                }}
              </mat-icon>
            </span>
          </span>
        </a>
        <div class="hover-img-box" *ngIf="hoveredItem === item" (mouseenter)="hoveredItem = item"
          [style.left.px]="tooltipLeft">
          <div class="hover-label">{{ item.label }}</div>
          <img *ngIf="item.hoverImg" [src]="item.hoverImg" />
          <span class="img-tooltip-arrow-left"></span>
        </div>

        <ul class="sub-menu" *ngIf="item.expanded">
          <li>
            <!-- TEXT ONLY -->
            <span *ngIf="isStringArray(item.subItems)" class="sub-list">
              {{ item.subItems[0] }}
            </span>

            <!-- PORT PERFORMANCE — grouped enterprise nav -->
            <ng-container *ngIf="item.pcGroupedNav">
              <nav class="pc-sidebar-nav" [ngClass]="{ 'pc-sidebar-nav--dark': isDarkMode() }" *ngIf="isSidebarOpen">
                <div class="pc-sidebar-nav__group" *ngFor="let group of pcNavGroups">
                  <button type="button" class="pc-sidebar-nav__header" (click)="togglePcNavGroup(group, $event)"
                    [attr.aria-expanded]="group.expanded">
                    <mat-icon class="pc-sidebar-nav__chevron">
                      {{ group.expanded ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <mat-icon class="pc-sidebar-nav__group-icon">{{
                      group.icon
                      }}</mat-icon>
                    <span class="pc-sidebar-nav__group-label">{{
                      group.label
                      }}</span>
                  </button>
                  <div class="pc-sidebar-nav__children" [class.pc-sidebar-nav__children--expanded]="group.expanded">
                    <div class="pc-sidebar-nav__children-inner">
                      <ng-container *ngFor="let link of group.items; let last = last">
                        <a *ngIf="canShowPcNavLink(link)" class="pc-sidebar-nav__link" [routerLink]="link.route"
                          [class.pc-sidebar-nav__link--active]="
                            isPcNavLinkActive(link)
                          " [attr.aria-current]="
                            isPcNavLinkActive(link) ? 'page' : null
                          ">
                          <span class="pc-sidebar-nav__tree">
                            <span class="pc-sidebar-nav__tree-line"
                              [class.pc-sidebar-nav__tree-line--last]="last"></span>
                          </span>
                          <mat-icon class="pc-sidebar-nav__link-icon">{{
                            link.icon
                            }}</mat-icon>
                          <span class="pc-sidebar-nav__link-label">{{
                            link.label
                            }}</span>
                        </a>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </nav>
              <ng-container *ngIf="!isSidebarOpen">
                <ng-container *ngFor="let group of pcNavGroups">
                  <ng-container *ngFor="let link of group.items">
                    <a *ngIf="canShowPcNavLink(link)" mat-list-item class="insideNav pc-sidebar-nav__collapsed-link"
                      [routerLink]="link.route" [class.pc-sidebar-nav__collapsed-link--active]="
                        isPcNavLinkActive(link)
                      " [matTooltip]="link.label" matTooltipPosition="right">
                      <mat-icon matListItemIcon class="subIcons">{{
                        link.icon
                        }}</mat-icon>
                    </a>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- SIMPLE MENU (EM / FUTURE) -->
            <ng-container *ngIf="isSimpleMenu(item.subItems) && !item.pcGroupedNav">
              <ng-container *ngFor="let sm of item.subItems">
                <a mat-list-item class="insideNav" [routerLink]="sm.route" [queryParams]="sm.queryParams"
                  routerLinkActive="selected-menu-item" #rla="routerLinkActive" [activated]="rla.isActive" [ngClass]="{
                    'active-item': rla.isActive,
                    'default-item': !rla.isActive,
                  }" *ngIf="canShow(sm)">
                  <mat-icon matListItemIcon class="subIcons" [ngStyle]="{
                      color: isItemActive(sm) ? 'activeColor' : 'defaultColor',
                    }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                    {{ sm.icon }}
                  </mat-icon>

                  <span matListItemTitle class="subItems" *ngIf="isSidebarOpen" [ngStyle]="{
                      color: isItemActive(sm) ? 'activeColor' : 'defaultColor',
                    }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                    {{ sm.label }}
                  </span>
                </a>
              </ng-container>
            </ng-container>

            <!-- NESTED MENU (Sailing Performance) -->
            <ng-container *ngIf="isNestedMenu(item.subItems)">
              <ng-container *ngFor="let m of item.subItems">
                <a mat-list-item routerLinkActive="selected-menu-item" [activated]="isItemActive(m)" class="insideNav"
                  [routerLink]="m.route" [queryParams]="m.queryParams" [ngClass]="{
                    'active-item': isItemActive(m),
                    'default-item': !isItemActive(m),
                  }" (click)="onNestedMenuClick(m)" *ngIf="canShow(m)">
                  <mat-icon matListItemIcon class="subIcons" [ngStyle]="{
                      color: isItemActive(m) ? activeColor : defaultColor,
                    }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                    {{ m.icon }}
                  </mat-icon>

                  <span matListItemTitle class="subItems" *ngIf="isSidebarOpen" [ngStyle]="{
                      color: isItemActive(m) ? activeColor : defaultColor,
                    }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                    {{ m.label }}
                    <mat-icon [ngStyle]="{
                        color: isItemActive(m) ? activeColor : defaultColor,
                      }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" class="arrows" *ngIf="m.subItems?.length">
                      {{
                      m.expanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
                      }}
                    </mat-icon>
                  </span>
                </a>

                <ng-container *ngFor="let sub of m.subItems">
                  <!-- IF HAS SUBITEMS -->
                  <ng-container *ngIf="sub.subItems">
                    <a mat-list-item class="insideNav subItem" [activated]="isItemActive(sub)" [ngClass]="{
                        'active-item': isItemActive(sub),
                        'default-item': !isItemActive(sub)
                      }" (click)="sub.expanded = !sub.expanded" *ngIf="
                        m.expanded &&
                        canShow(sub)
                      ">
                      <mat-icon matListItemIcon class="subIconsSmall" [ngStyle]="{
                          color: isItemActive(sub) ? 'activeColor' : 'defaultColor'
                        }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                        {{ sub.icon }}
                      </mat-icon>

                      <span matListItemTitle class="subItems sidebar-text" *ngIf="isSidebarOpen" [ngStyle]="{
                          color: isItemActive(sub) ? 'activeColor' : 'defaultColor'
                        }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" [matTooltip]="sub.label">
                        {{ sub.label }}
                        <mat-icon [ngStyle]="{
                            color: isItemActive(sub) ? 'activeColor' : 'defaultColor'
                          }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" class="arrows">
                          {{
                          sub.expanded ? "keyboard_arrow_up" : "keyboard_arrow_down"
                          }}
                        </mat-icon>
                      </span>
                    </a>

                    <ng-container *ngFor="let subSub of sub.subItems">
                      <a mat-list-item class="insideNav subItem subSubItem" [routerLink]="subSub.route"
                        [queryParams]="subSub.queryParams" routerLinkActive="selected-menu-item"
                        #ssrla="routerLinkActive" [activated]="ssrla.isActive" [ngClass]="{
                          'active-item': ssrla.isActive,
                          'default-item': !ssrla.isActive
                        }" *ngIf="
                          m.expanded &&
                          sub.expanded &&
                          canShow(subSub)
                        ">
                        <mat-icon matListItemIcon class="subIconsSmall" [ngStyle]="{
                            color: ssrla.isActive ? 'activeColor' : 'defaultColor'
                          }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                          {{ subSub.icon }}
                        </mat-icon>

                        <span matListItemTitle class="subItems sidebar-text" *ngIf="isSidebarOpen" [ngStyle]="{
                            color: ssrla.isActive ? 'activeColor' : 'defaultColor'
                          }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" [matTooltip]="subSub.label">
                          {{ subSub.label }}
                        </span>
                      </a>
                    </ng-container>
                  </ng-container>

                  <!-- IF NO SUBITEMS (Original logic) -->
                  <ng-container *ngIf="!sub.subItems">
                    <a mat-list-item class="insideNav subItem" [routerLink]="sub.route" [queryParams]="sub.queryParams"
                      routerLinkActive="selected-menu-item" #srla="routerLinkActive" [activated]="srla.isActive"
                      [ngClass]="{
                        'active-item': srla.isActive,
                        'default-item': !srla.isActive
                      }" *ngIf="
                        m.expanded &&
                        canShow(sub)
                      ">
                      <mat-icon matListItemIcon class="subIconsSmall" [ngStyle]="{
                          color: srla.isActive ? 'activeColor' : 'defaultColor'
                        }" [ngClass]="{ 'dark-sidebar': isDarkMode() }">
                        {{ sub.icon }}
                      </mat-icon>

                      <span matListItemTitle class="subItems sidebar-text" *ngIf="isSidebarOpen" [ngStyle]="{
                          color: srla.isActive ? 'activeColor' : 'defaultColor'
                        }" [ngClass]="{ 'dark-sidebar': isDarkMode() }" [matTooltip]="sub.label">
                        {{ sub.label }}
                      </span>
                    </a>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </li>
        </ul>
      </div>
      <div class="version" *ngIf="isSidebarOpen">
        <p class="vText">© Meraki</p>
        <p class="vText" *ngIf="module === 'Sailing Performance'">
          Version: 4.2.5
        </p>
        <p class="vText" *ngIf="module === 'Port Performance'">
          Version: 1.3.6
        </p>
        <p class="vText" *ngIf="module === 'Cargo Heating'">Version: 1.4.5</p>
        <p class="vText" *ngIf="module === 'Emission Analytics'">
          Version: 1.1.0
        </p>
      </div>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content [style.margin-left]="contentWidth" [class.dark-bgv]="isDarkMode()">
    <div class="bgv">
      <!-- <div class="new-year-popup" *ngIf="showNewYearPopup">
        <div class="content">
          <h3>Happy New Year 2026! <span class="icon">🎉</span></h3>
          <p>{{ greetingMessage }}</p>
        </div>

        <button class="close-btn" (click)="closeNewYearPopup()">x</button>
      </div> -->

      <ngx-ui-loader *ngIf="!isNoLoaderPage"></ngx-ui-loader><router-outlet> </router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>